import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faq = [
  {
    "q": "Do you provide custom-sized structural fabrication solutions?",
    "a": "Yes, we specialize in custom structural steel fabrication. All structures, including platforms, mezzanines, and frames, are built and sized precisely based on client blueprints and load requirements.",
  },
  {
    "q": "What types of tanks and pressure vessels can you fabricate?",
    "a": "We fabricate a wide range of vessels including storage tanks, process tanks, silos, and custom-designed pressure vessels using materials like Stainless Steel (SS) and Carbon Steel (CS) for various industries.",
  },
  {
    "q": "Do you offer on-site welding and erection services for large structures?",
    "a": "Yes, our certified engineers and welders provide complete on-site erection, welding, and assembly services for large structural projects and tank installations.",
  },
  {
    "q": "Are your welding procedures certified according to industry standards?",
    "a": "Absolutely. All our welding procedures are certified, and our welders are qualified to meet international standards such as ASME, AWS, and ISO, ensuring the highest level of joint integrity and safety.",
  },
  {
    "q": "What kind of surface finishing options do you offer for fabricated steel?",
    "a": "We provide various surface protection and finishing options including sandblasting, industrial painting, epoxy coating, galvanization, and polishing (for SS) to enhance durability and corrosion resistance.",
  },
  {
    "q": "Can you handle heavy-duty structural fabrication for industrial plants?",
    "a": "Yes, we specialize in heavy-duty fabrication for industrial applications, including equipment skids, heavy machinery bases, pipe racks, and factory extensions, ensuring robust design and precise tolerances.",
  },
  {
    "q": "What Non-Destructive Testing (NDT) methods do you use for quality control?",
    "a": "Our quality control includes stringent NDT methods such as Ultrasonic Testing (UT), Magnetic Particle Testing (MPT), Radiographic Testing (RT), and Dye Penetrant Testing (DPT) to ensure weld soundness and structural integrity.",
  },
  {
    "q": "What is the typical lead time for a custom fabricated tank?",
    "a": "Lead time depends on the tank's capacity, material specification (e.g., thickness, grade), and complexity (e.g., internal coils, agitators). We provide a detailed timeline upon design finalization.",
  },
  {
    "q": "Do you provide necessary design calculations and drawings for fabrication projects?",
    "a": "Yes, we provide complete engineering support, including detailed 3D modeling, fabrication drawings, and necessary structural and stress calculations certified by professional engineers.",
  },
  {
    "q": "What materials do you commonly use for pressure vessel fabrication?",
    "a": "We commonly use certified grades of Carbon Steel (SA-516 Grade 70) and Stainless Steel (SS 304, SS 316) specifically suited for the operating pressure, temperature, and corrosive media of the vessel.",
  },
  {
    "q": "What kind of warranty do you provide on your fabricated structures and vessels?",
    "a": "We offer a comprehensive warranty covering our materials and workmanship. The specific warranty period is detailed in the project contract and complies with industry standards.",
  },
  {
    "q": "How do you ensure site safety during on-site fabrication and installation?",
    "a": "We maintain strict adherence to international safety protocols (e.g., OSHA/local regulations). Our team follows rigorous HSE (Health, Safety, and Environment) plans, including permit-to-work systems and continuous risk assessment.",
  },
  {
    "q": "Can you assist with the logistics and transportation of large fabricated items?",
    "a": "Yes, we manage the complete logistics, including specialized transportation and lifting arrangements, to ensure the safe and timely delivery of large, oversized fabricated structures and tanks to the project site."
  }
];

export default function ProductFAQ() {
  return (
    <Box sx={{ py: 10, background: "#f8f9ff" }}>
      <Container maxWidth="md">
        {/* ----- TITLE ----- */}
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{
            mb: { xs: 3, md: 4 }, // smaller spacing on mobile
            textAlign: "center",
            color: "#1a237e",
            fontSize: { xs: "1.6rem", md: "2.2rem" }, // smoother scaling
            lineHeight: 1.3, // prevents text from looking cramped
            px: { xs: 2, md: 0 }, // small padding for narrow screens
          }}
        >
          Frequently Asked Questions
        </Typography>

        {/* ----- FAQ ACCORDIONS ----- */}
        {faq.map((item, i) => (
          <Accordion
            key={i}
            sx={{
              mb: 2,
              borderRadius: "12px !important",
              boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
              "&::before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#d50000" }} />}
              sx={{
                background: "#fff",
                borderRadius: "12px",
                "& .MuiAccordionSummary-content": {
                  fontWeight: 700,
                  color: "#1a237e",
                },
              }}
            >
              <Typography fontWeight={700}>{item.q}</Typography>
            </AccordionSummary>

            <AccordionDetails
              sx={{
                background: "#fafbfd",
                borderRadius: "0 0 12px 12px",
                color: "#333",
                fontSize: "0.98rem",
                lineHeight: 1.7,
              }}
            >
              {item.a}
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
}
